/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { DummyErrors2, DummyErrors2Interface } from "../DummyErrors2";

const _abi = [
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "takerTokenFilledAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "takerTokenFillAmount",
        type: "uint256",
      },
    ],
    name: "BatchFillIncompleteError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "minValidSalt",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "oldMinValidSalt",
        type: "uint256",
      },
    ],
    name: "CancelSaltTooLowError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "takerTokenFilledAmount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "takerTokenFillAmount",
        type: "uint256",
      },
    ],
    name: "FillOrKillFailedError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
    ],
    name: "InvalidSignerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "ONLY_OWNER_ERROR_SELECTOR",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
    ],
    name: "OnlyOrderMakerAllowed",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "OnlyOwnerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "txOrigin",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderTxOrigin",
        type: "address",
      },
    ],
    name: "OrderNotFillableByOriginError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderSender",
        type: "address",
      },
    ],
    name: "OrderNotFillableBySenderError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "taker",
        type: "address",
      },
      {
        internalType: "address",
        name: "orderTaker",
        type: "address",
      },
    ],
    name: "OrderNotFillableByTakerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "orderStatus",
        type: "uint8",
      },
    ],
    name: "OrderNotFillableError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "orderHash",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "signer",
        type: "address",
      },
      {
        internalType: "address",
        name: "maker",
        type: "address",
      },
    ],
    name: "OrderNotSignedByMakerError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "refundAmount",
        type: "uint256",
      },
    ],
    name: "ProtocolFeeRefundFailed",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "TRANSFER_OWNER_TO_ZERO_ERROR_BYTES",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "TransferOwnerToZeroError",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
];

const _bytecode =
  "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";

export class DummyErrors2__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<DummyErrors2> {
    return super.deploy(overrides || {}) as Promise<DummyErrors2>;
  }
  getDeployTransaction(
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DummyErrors2 {
    return super.attach(address) as DummyErrors2;
  }
  connect(signer: Signer): DummyErrors2__factory {
    return super.connect(signer) as DummyErrors2__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): DummyErrors2Interface {
    return new utils.Interface(_abi) as DummyErrors2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DummyErrors2 {
    return new Contract(address, _abi, signerOrProvider) as DummyErrors2;
  }
}
